<template>
  <login-form
    title="Login"
    go-action="Submit"
    @submit="login"
    :loading="loading"
    logo="/logo.png"
    :errors="errors"
  >
    <phone-input v-model="username" autofocus :dark="darkTheme" />
  </login-form>
</template>

<script>
import LoginForm from '@/components/Form'
import PhoneInput from '@/components/PhoneInput'
import { mapGetters, mapMutations } from 'vuex'
import { SET_USER_ID, STATE_CHALLENGE } from '@/store'
import { ROUTE_NAME as ROUTE_NAME_USER_PIN } from '@/views/UserPIN'
import { ROUTE_NAME as ROUTE_NAME_USER_CODE } from '@/views/UserCode'
import mixinHandleError from '@/mixins/handle-error'

export const ROUTE_NAME = 'LoginUser'

export default {
  name: ROUTE_NAME,
  mixins: [mixinHandleError],
  components: {
    LoginForm,
    PhoneInput
  },
  computed: {
    ...mapGetters({
      challenge: STATE_CHALLENGE
    }),
    darkTheme () {
      return this.$vuetify.theme.dark
    }
  },
  data: () => ({
    username: '',
    loading: false
  }),
  methods: {
    ...mapMutations({
      setUserID: SET_USER_ID
    }),
    async login () {
      this.loading = true
      this.clearErrors()
      try {
        const resp = await this.axios.post('/api/v1/login', {
          challenge: this.challenge,
          username: this.username
        })

        this.setUserID(resp.data.uid)

        let nextRouteName
        switch (resp.data.type) {
          case 'pin':
            nextRouteName = ROUTE_NAME_USER_PIN
            break
          case 'code':
            nextRouteName = ROUTE_NAME_USER_CODE
            break
          default:
            throw new Error(
              `unknown pin response: ${JSON.stringify(resp, null, 2)}`
            )
        }
        this.$router.push({
          name: nextRouteName
        })
      } catch (err) {
        this.storeError(err)
      }
      this.loading = false
    }
  }
}
</script>
